// extracted by mini-css-extract-plugin
var _1 = "ra-error";
var _2 = "ra-error-logo";
var _3 = "ra-error-main";
export { _1 as "errorCls", _2 as "errorLogoCls", _3 as "errorMainCls" }
